module.exports = __webpack_public_path__ + "img/flash-green.ca7cee0d.svg";